module.exports = __webpack_public_path__ + "static/assets/e02e23a09a56d0a8545c8bcb12039d64.svg";